import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Strings} from "../Types";
import {KeyOfIcons} from "../components/CONSTANTS";
import {RootState} from "../store/store";
import {schemas} from "../config";

export type PageI = {
    custom?: boolean;
    name: string,
    icon?: KeyOfIcons
    lang: Strings
    func?: string
    disabled?: boolean
};

export interface ProjectI {
    name: string;
    id: string;
    isUserAdmin: boolean
    activePage: number
    pages: PageI[];
    iconsStyle: string
}

const ADMIN_IDS = ['1', '150'];

export const projectSlice = createSlice({
    name: 'project',
    initialState: {} as ProjectI,
    reducers: {
        setProject(state, action: PayloadAction<ProjectI>) {
            return {...action.payload}
        },
        setActivePage(state, action: PayloadAction<number>) {
            state.activePage = action.payload
        },
        setIconsStyle(state, action: PayloadAction<string>) {
            state.iconsStyle = action.payload
        },
        setIsUserAdmin(state, action: PayloadAction<string>) {
            state.isUserAdmin = ADMIN_IDS.includes(action.payload)
        }
    },
})

export const selectProjectSchema = (state: RootState) => schemas[state.project.name];
export const selectActiveTableSchema = (state: RootState) => schemas[state.project.name].tables[state.tables.activeTable];
export const selectActiveTable = (state: RootState) => state.tables.activeTable;
export const selectTableSchema = (tableKey: string) => (state: RootState) => schemas[state.project.name].tables[tableKey];

// Action creators are generated for each case reducer function
export const {setProject, setActivePage, setIconsStyle, setIsUserAdmin} = projectSlice.actions

export default projectSlice.reducer
